import React from 'react'
import { FiChevronDown, FiChevronUp } from "react-icons/fi";

const Icons = (props) => {
    let icon;
    switch (props.name) {
        case 'FiChevronDown':
            icon = <FiChevronDown style={props.style}/>;
            break;
        case 'FiChevronUp':
            icon = <FiChevronUp style={props.style}/>;
            break;
        default:
            break;
    }
    return icon
};

export default Icons;
